import { useState } from 'react';

import { ChatMessage } from '../components/ChatMessagesDialog';

export interface ExportCheckboxesState {
  showAdvance: boolean;
  showRate: boolean;
  showRateComposition: boolean;
  showArrearRate: boolean;
  showAmount: boolean;
  showAmountAdvance: boolean;
  showAmountRetained: boolean;
  showAmountDifference: boolean;
  showAmountComissionIva: boolean;
  showAmountTotalApplied: boolean;
  showDraftBalance: boolean;
  showExpenses: boolean;
  showGuaranteeAmount: boolean;
  showPayouts: boolean;
  showExecutiveNameAsUser: boolean;
  showExpensesDetails: boolean;
  showDueDate: boolean;
  showDays: boolean;
  showChatAsObservations: boolean;
  showFundRate: boolean;
  showSpread: boolean;
  selectedChatMessages: string[];
  selectedChatMessagesObjects: ChatMessage[];
}

export interface ExportCheckboxesSetters {
  setShowAdvance: (value: boolean) => void;
  setShowRate: (value: boolean) => void;
  setShowRateComposition: (value: boolean) => void;
  setShowArrearRate: (value: boolean) => void;
  setShowAmount: (value: boolean) => void;
  setShowAmountAdvance: (value: boolean) => void;
  setShowAmountRetained: (value: boolean) => void;
  setShowAmountDifference: (value: boolean) => void;
  setShowAmountComissionIva: (value: boolean) => void;
  setShowAmountTotalApplied: (value: boolean) => void;
  setShowDraftBalance: (value: boolean) => void;
  setShowExpenses: (value: boolean) => void;
  setShowGuaranteeAmount: (value: boolean) => void;
  setShowPayouts: (value: boolean) => void;
  setShowExecutiveNameAsUser: (value: boolean) => void;
  setShowExpensesDetails: (value: boolean) => void;
  setShowDueDate: (value: boolean) => void;
  setShowDays: (value: boolean) => void;
  setShowChatAsObservations: (value: boolean) => void;
  setShowFundRate: (value: boolean) => void;
  setShowSpread: (value: boolean) => void;
  setSelectedChatMessages: (value: string[]) => void;
  setSelectedChatMessagesObjects: (value: ChatMessage[]) => void;
}

export interface UseExportCheckboxesOptions {
  includeRateComposition?: boolean;
  includePayouts?: boolean;
}

export const useExportCheckboxes = (
  options: UseExportCheckboxesOptions = {},
): [ExportCheckboxesState, ExportCheckboxesSetters] => {
  const { includeRateComposition = false, includePayouts = false } = options;

  const [showAdvance, setShowAdvance] = useState(true);
  const [showRate, setShowRate] = useState(true);
  const [showRateComposition, setShowRateComposition] = useState(true);
  const [showArrearRate, setShowArrearRate] = useState(true);
  const [showAmount, setShowAmount] = useState(true);
  const [showAmountAdvance, setShowAmountAdvance] = useState(true);
  const [showAmountRetained, setShowAmountRetained] = useState(true);
  const [showAmountDifference, setShowAmountDifference] = useState(true);
  const [showAmountComissionIva, setShowAmountComissionIva] = useState(true);
  const [showAmountTotalApplied, setShowAmountTotalApplied] = useState(true);
  const [showDraftBalance, setShowDraftBalance] = useState(true);
  const [showExpenses, setShowExpenses] = useState(true);
  const [showGuaranteeAmount, setShowGuaranteeAmount] = useState(true);
  const [showPayouts, setShowPayouts] = useState(true);
  const [showExecutiveNameAsUser, setShowExecutiveNameAsUser] = useState(true);
  const [showExpensesDetails, setShowExpensesDetails] = useState(true);
  const [showDueDate, setShowDueDate] = useState(true);
  const [showDays, setShowDays] = useState(true);
  const [showChatAsObservations, setShowChatAsObservations] = useState(false);
  const [showFundRate, setShowFundRate] = useState(true);
  const [showSpread, setShowSpread] = useState(true);
  const [selectedChatMessages, setSelectedChatMessages] = useState<string[]>(
    [],
  );
  const [selectedChatMessagesObjects, setSelectedChatMessagesObjects] =
    useState<ChatMessage[]>([]);

  const state: ExportCheckboxesState = {
    showAdvance,
    showRate,
    showRateComposition: includeRateComposition ? showRateComposition : false,
    showArrearRate,
    showAmount,
    showAmountAdvance,
    showAmountRetained,
    showAmountDifference,
    showAmountComissionIva,
    showAmountTotalApplied,
    showDraftBalance,
    showExpenses,
    showGuaranteeAmount,
    showPayouts: includePayouts ? showPayouts : false,
    showExecutiveNameAsUser,
    showExpensesDetails,
    showDueDate,
    showDays,
    showChatAsObservations,
    showFundRate,
    showSpread,
    selectedChatMessages,
    selectedChatMessagesObjects,
  };

  const setters: ExportCheckboxesSetters = {
    setShowAdvance,
    setShowRate,
    setShowRateComposition,
    setShowArrearRate,
    setShowAmount,
    setShowAmountAdvance,
    setShowAmountRetained,
    setShowAmountDifference,
    setShowAmountComissionIva,
    setShowAmountTotalApplied,
    setShowDraftBalance,
    setShowExpenses,
    setShowGuaranteeAmount,
    setShowPayouts,
    setShowExecutiveNameAsUser,
    setShowExpensesDetails,
    setShowDueDate,
    setShowDays,
    setShowChatAsObservations,
    setShowFundRate,
    setShowSpread,
    setSelectedChatMessages,
    setSelectedChatMessagesObjects,
  };

  return [state, setters];
};
